// `unknown` rather than `number` because some call sites read fovea off untyped
// props. Non-numeric input is rejected outright: coercing it would turn a
// missing measurement (null, "") into a measured 0 dB, which reads as "no light
// seen" on the report and is exported as such in the OPV payload. A genuine
// numeric 0 is a valid measurement and is preserved.
export function getDisplayedFovealThreshold(rawThreshold: unknown): number | null {
  if (typeof rawThreshold !== "number" || !Number.isFinite(rawThreshold) || rawThreshold < 0) {
    return null;
  }

  if (rawThreshold < 20) return Math.ceil(rawThreshold * 1.25);
  return Math.min(40, rawThreshold + 8);
}
